import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import HeaderCard from "../../../Common/Component/HeaderCard";
import Chart from 'react-apexcharts';
import config from "../../../../config";
import axios from "axios";
import { useTranslation } from 'react-i18next';

const SalesComparisonMom = ({ year, propertyMallCode }) => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();
    const selectedYear = year === '' ? currentYear : year;
    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_id = localStorage.getItem("propertyAccess");
    const [currency, setCurrency] = useState('');
    const [currentYearData, setCurrentYearData] = useState([]);
    const [previousYearData, setPrevioueYearData] = useState([]);
    const [apiUrl, setApiUrl] = useState('');
    const [data, setData] = useState([]);

    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    useEffect(() => {
        axios
            .post(`${config.hostname}/country/getcountrybyconcessionaire`, { country_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setCurrency(response.data[0].country_currency);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        if (year !== '' || propertyMallCode !== '') {
            setApiUrl('dashboardfiltered/salescomparisonmom')
            const data1 = {
                concessionaire_id,
                property_id,
                year,
                propertyMallCode
            }
            setData(data1)
        }
        else {
            setApiUrl('dashboard/salescomparisonmom')
            const data2 = {
                concessionaire_id,
                property_id
            }
            setData(data2)
        }
    }, [year, propertyMallCode]);

    useEffect(() => {
        if (apiUrl !== '') {
            axios
                .post(`${config.hostname}/${apiUrl}`, data, configheader)
                .then((response) => {
                    // Sort the currentYearSales and previousYearSales arrays by month
                    const currentYearSorted = response.data.currentYearSales
                        .sort((a, b) => {
                            const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                            return months.indexOf(a.month) - months.indexOf(b.month);
                        })
                        .map(item => (item.totalSales / 1000000).toFixed(2));
                    setCurrentYearData(currentYearSorted);

                    const previousYearSorted = response.data.previousYearSales.sort((a, b) => {
                        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                        return months.indexOf(a.month) - months.indexOf(b.month);
                    }).map(item => (item.totalSales / 1000000).toFixed(2));
                    setPrevioueYearData(previousYearSorted)
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [apiUrl, data]);

    const apexColumnChartsone = {

        series: [
            {
                name: selectedYear - 1,
                data: previousYearData
            }, {
                name: selectedYear,
                data: currentYearData
            }],
        options: {
            chart: {
                type: 'bar',
                height: 350,
                toolbar: { show: false },
                fontFamily: 'inherit',
                background: 'transparent',
                animations: { speed: 400 },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '58%',
                    borderRadius: 5,
                    borderRadiusApplication: 'end',
                },
            },
            dataLabels: { enabled: false },
            // Prior year muted purple, current year accent blue → clear emphasis.
            colors: ['#A78BFA', '#3B82F6'],
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    type: 'vertical',
                    shadeIntensity: 0.25,
                    opacityFrom: 1,
                    opacityTo: 0.85,
                    stops: [0, 100],
                },
            },
            stroke: { show: true, width: 2, colors: ['transparent'] },
            grid: { strokeDashArray: 4, xaxis: { lines: { show: false } } },
            xaxis: {
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                axisBorder: { show: false },
                axisTicks: { show: false },
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        return val.toFixed(2);
                    },
                },
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                markers: { radius: 12 },
                fontSize: '13px',
            },
            states: { hover: { filter: { type: 'lighten', value: 0.06 } } },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return currency + ' ' + val + ' ' + t('millions');
                    },
                },
            },
        },
    };

    return (
        <Fragment>
            <Col sm='12' >
                <Card>
                    <HeaderCard title={<div style={{ display: 'flex', alignItems: 'center' }}>
                        <div>{t('Sales Comparison')}</div>
                        <div style={{ fontSize: '0.7em', color: '#777', marginLeft: '10px' }}>{t('Month on month')}</div>
                    </div>} />
                    <CardBody>
                        <div id='column-chart'>
                            <Chart options={apexColumnChartsone.options} series={apexColumnChartsone.series} type="bar" height={350} />
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
}

export default SalesComparisonMom